import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateNeuroRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateNeuro extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Neuromuscular Re-Ed (97112)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateNeuroRow key={result.XLTMPNENO} id={result.XLTMPNENO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPNEURO ?
            Object.keys(state.entities.notes.MLTMPNEURO)
                .filter(key => {
                    return (state.entities.notes.MLTMPNEURO[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPNEURO[a].XLTMPNEORDER - state.entities.notes.MLTMPNEURO[b].XLTMPNEORDER)
                .map(key => state.entities.notes.MLTMPNEURO[key]) : [],
    };
}

const connectedAlTemplateNeuro = connect(mapStateToProps)(AlTemplateNeuro);
export { connectedAlTemplateNeuro as AlTemplateNeuro };

